import React from "react";
import { ChevronRight } from "../../assets/svgs";
import "./styles.scss";

const StepCard = ({ cardHeading, cardDescription, step, isActive }) => {
  return (
    <div className={`card-container ${!isActive && "opacity-50"}`}>
      <div className={`text-wrapper`}>
        <p className={`number-container`}>{step}</p>
        <div className="card-content-wrapper">
          <p className={`title-text`}>{cardHeading}</p>
          <p className={`subtitle-text`}>{cardDescription}</p>
        </div>
      </div>
      <img className={`right-Icon`} src={ChevronRight} alt="." />
    </div>
  );
};

export default StepCard;
